import { Injectable } from '@angular/core';
import {
  HERE_API_KEY,
  HERE_OLD_APP_CODE,
  HERE_OLD_APP_ID,
  IAutocompleteResponse,
  IGeocodingResponse,
  ILatLon,
  IReverseGeocodingResponse,
  LatLon,
} from '@curbnturf/entities';
import { toLatLon } from '@curbnturf/helpers';
import { CachedHttpClient } from '@curbnturf/network';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class GeocodingService {
  constructor(private http: CachedHttpClient) {}

  fetch(address: string): Observable<LatLon> {
    return this.http
      .get<IGeocodingResponse>(
        `https://geocode.search.hereapi.com/v1/geocode?apiKey=${HERE_API_KEY}&q=${encodeURI(address)}`,
      )
      .pipe(
        map((response) => {
          if (response?.items?.length > 0) {
            return toLatLon(response.items[0].position);
          }

          return new LatLon();
        }),
      );
  }

  reverse(coordinates: ILatLon): Observable<string> {
    return this.http
      .get<IReverseGeocodingResponse>(
        `https://revgeocode.search.hereapi.com/v1/revgeocode?apiKey=${HERE_API_KEY}&at=${coordinates.lat},${coordinates.lon}&lang=en-US`,
      )
      .pipe(
        map((response) => {
          if (response?.items?.length > 0 && response.items[0].address) {
            const address = response?.items[0].address;
            if (address.city && address.state) {
              return `${address.city}, ${address.state}`;
            }

            if (address.city) {
              return `${address.city}`;
            }

            if (address.state) {
              return `${address.state}`;
            }
          }

          return 'unknown';
        }),
      );
  }

  autocomplete(partialAddress: string): Observable<IAutocompleteResponse> {
    // this end point is only in maintenance mode but newer version is in Beta
    return this.http.get<IAutocompleteResponse>(
      `https://autocomplete.search.hereapi.com/v1/autocomplete?apiKey=${HERE_API_KEY}&in=countryCode:USA&q=${encodeURI(
        partialAddress,
      )}`,
    );
  }
}
